<template>
  <div class="">
    <el-row>
      <el-col :span="5">
        <el-checkbox-group v-model="mainSelect">
          <el-checkbox
            :label="templateValueArray.id"
            :key="templateValueArray.id"
            @change="selectMainOption"
            :checked="templateValueArray.selected"
            >{{ templateValueArray.name }}</el-checkbox
          >
        </el-checkbox-group>
      </el-col>
      <el-col :span="19">
        <el-checkbox-group v-model="valueSelectList">
          <el-checkbox
            v-for="item in templateChildValue"
            :label="item.id"
            :key="item.id"
            :checked="item.selected"
            @change="existSelectChild"
            >{{ item.name }}</el-checkbox
          >
        </el-checkbox-group>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "templateValueOption",
  components: {},
  props: ["templateArray", "index"],
  data() {
    return {
      mainSelect: [],
      valueSelectList: [],
      templateValueArray: [],
      templateChildValue: [],
    };
  },
  watch: {
    valueSelectList: "getSelectValue",
  },
  computed: {},
  methods: {
    getSelectValue() {
      this.$props.templateArray.selected = this.mainSelect.length > 0;
      if (this.$props.templateArray.children === null) {
        this.$message({
          message: "该选项没有可用值",
          type: "error",
        });
        return;
      }
      this.$props.templateArray.children.forEach((e) => {
        if (this.valueSelectList.findIndex((item) => item === e.id) === -1) {
          e.selected = false;
        } else {
          e.selected = true;
        }
      });

      this.$emit(
        "changeTemplateValueArray",
        this.$props.index,
        this.$props.templateArray
      );
    },
    //选中主项目，则全选子项目，反之则全不选
    selectMainOption() {
      this.valueSelectList = [];
      if (this.mainSelect.length > 0) {
        if (this.templateChildValue != null) {
          this.templateChildValue.forEach((e) => {
            this.valueSelectList.push(e.id);
          });
        }
      }
    },
    //选中子项目，则选中主项目
    existSelectChild() {
      if (this.valueSelectList.length > 0) {
        this.mainSelect = [this.templateValueArray.id];
      } else {
        this.mainSelect = [];
      }
    },
  },
  created() {},
  mounted() {
    this.templateValueArray = this.$props.templateArray;
    this.templateChildValue = this.$props.templateArray.children;
  },
};
</script>
<style lang="less" scoped></style>
